/* tslint:disable */

/**
 */
export class Production {
    NB_PROD_WEEK_PER_YEAR?: number;
    ID_PRODUCTION?: number;
    DAILY_PROD?: number;
    DAILY_STARTUP?: number;
    WEEKLY_PROD?: number;
    PROD_FLOW_RATE?: number;
    ID_STUDY?: number;
    AMBIENT_TEMP?: number;
    AMBIENT_HUM?: number;
    AVG_T_DESIRED?: number;
    AVG_T_INITIAL?: number;
    APPROX_DWELLING_TIME?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/production.ts